var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistoryBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.79 61.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#263d50;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "El\\u0151zm\\xE9nyek"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.73,51.19a27.27,27.27,0,1,0-6.54-17.7,2.88,2.88,0,0,0,0,.41"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.19,
    y1: 1,
    x2: 43.02,
    y2: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.49,
    y1: 20.59,
    x2: 33.49,
    y2: 33.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.49,
    y1: 33.49,
    x2: 41.39,
    y2: 38.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 53.83,
    y1: 33.9,
    x2: 60.85,
    y2: 33.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.49,
    y1: 13.19,
    x2: 33.49,
    y2: 6.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.49,
    y1: 60.82,
    x2: 33.49,
    y2: 53.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "14.72 28.67 6.1 33.9 6.09 33.91 0.85 25.29"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryBlack);
export default __webpack_public_path__ + "static/media/historyBlack.c7f4056949e3cc5e35ce5a4f3d5ee99e.svg";
export { ForwardRef as ReactComponent };